import React, {useCallback, useEffect, useMemo, useState} from "react";
import styles from "./pages.module.scss"
import {ReactComponent as DeleteIcon} from "../../../assets/editors/delete_icon.svg"
import {useTypedSelector} from "../../../hooks/useTypeSelector";
import {Page} from "./page/page";
import {useDispatch} from "react-redux";
import {
    changeQualificationStatusForPage,
    deleteImagesFromPages,
    deletePageFromPages,
    insertPageToFlyer, movePageBeforeInFlyer, setSelectedPageForTabs, uploadImagesToPages
} from "../../../store/actionCreators/pagesActionCreators";
import {PageSpinner} from "../../com/pagesTab/pagesSpinner/spinner";
import {ActionType} from '../../../store/actionTypes';
import StatusPopup, {StatusPopupType} from "../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "./getSetttingsForPopup";
import LabelFileSelector from "../../../com/labelFileSelector/LabelFileSelector";
import {FlyerPageDto, SelectPageForTabsDto, UserDto} from "../../../dtos";
import {updateFlyerDetailsState} from "../../../store";
import {Box, Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {QualityCheck} from "../../../com/qualityCheck/qualityCheck";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_DISABLE_TABS,
} from "../../../globals/EventDispatcher";
import {startUploadingImagesProgressPopup} from "../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {FlyerDetailsRightPanel} from "../flyerDetailsPopup/flyerDetailsRightPanel";
import {makeStyles} from "@mui/styles";
import InfiniteScroll from 'react-infinite-scroller';
import {toggleFlyerRightPanel} from "../../../store/actionCreators/toggleActionForEditorActionCreators";

const useStyles = makeStyles(() => ({
    contentPagesWrapper: {
        height: "auto",
        maxHeight: "100%",
        // flex: "1 1 auto",
        overflow: "auto",
        // display: "flex",
        // flexFlow: "row",
        // flexWrap: "wrap",
        // columnGap: "2%",
        // rowGap: "2%",
        // margin: "5px 10px 0",
        padding: "12px",
        marginTop: "0!important",
        // "&::-webkit-scrollbar": {
        //     width: "12px",
        // },
        //
        // "&::-webkit-scrollbar-track": {
        //     WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
        //     borderRadius: "10px",
        // },
        //
        // "&::-webkit-scrollbar-thumb": {
        //     borderRadius: "10px",
        //     WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.5)",
        // }
    }
}))


export interface PagesDataStateDto {
    selectedPages: FlyerPageDto[];
    lastSelectedPage: FlyerPageDto[];
    pagesFlyer: FlyerPageDto[];
    pageNoForMoveBefore: number;
    dataForUploadImageToPage: DataForUpload;
    notLoaderPagesImagesCodes: NotLoaderArray[];
    isRemoveAllPagesFromFlyer: boolean;
    isSelectedAll: boolean;
    isDoubleClick?: boolean;
}

export interface NotLoaderArray {
    index: number;
}

export interface DataForUpload {
    Images: any,
    Pages: any,
    UiLanguageCultureCode: string

}

export const Pages = () => {
    const dispatch = useDispatch();
    const isMd = useMediaQuery(`(max-width:1199px)`);
    const isXs = useMediaQuery(`(max-width:699px)`);
    const isSm = useMediaQuery(`(max-width:899px)`);
    const isMdForContent = useMediaQuery(`(max-width:1299px)`);
    const isLg = useMediaQuery(`(max-width:1635px)`);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let pagesState = useTypedSelector((state) => state.pages);
    let {uploadImagesPopup} = useTypedSelector((state) => state);
    let selectedPagesForTabState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    let {isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);
    const [pagesDataState, setPagesDataState] = useState<PagesDataStateDto>({
        selectedPages: [],
        lastSelectedPage: [],
        pagesFlyer: [],
        pageNoForMoveBefore: 1,
        dataForUploadImageToPage: {
            Images: [{}],
            Pages: [],
            UiLanguageCultureCode: 'en-US'
        },
        notLoaderPagesImagesCodes: [],
        isRemoveAllPagesFromFlyer: false,
        isSelectedAll: false,
        isDoubleClick: false
    });
    //states for popups
    const [modalSetup, setModalSetup] = useState<{
        isOpen: boolean,
        modalName: string,
        messages: string[],
    }>({
        isOpen: false,
        modalName: "",
        messages: []
    });
    const itemsPerPage = 250;
    const [hasMore, setHasMore] = useState(true);
    const [records, setRecords] = useState(itemsPerPage);
    // const [pages, setPages] = useState<JSX.Element[]>([]);

    const classes = useStyles();
    const rightPanelAnimationTimeInMs = 500;
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }

    useEffect(() => {
        return () => {
            setPagesDataState({
                selectedPages: [],
                lastSelectedPage: [],
                pagesFlyer: [],
                pageNoForMoveBefore: 1,
                dataForUploadImageToPage: {
                    Images: [{}],
                    Pages: [],
                    UiLanguageCultureCode: 'en-US'
                },
                notLoaderPagesImagesCodes: [],
                isRemoveAllPagesFromFlyer: false,
                isSelectedAll: false,
                isDoubleClick: false
            })
        }
    }, []);


    useEffect(() => {
        if (isMd && isShowRightPanel) {
            dispatch(toggleFlyerRightPanel())
        }
    }, [isMd])


    useEffect(() => {
        if (flippingFlyerState.type === ActionType.GET_FLIPPING_FLYER_COMPLETED || flippingFlyerState.type === ActionType.POST_FLIPPING_FLYER_SUCCESS) {
            if (!pagesDataState.selectedPages.length && !pagesDataState.lastSelectedPage.length) {
                console.log(flyerDetailsState);
                setPagesDataState({
                    ...pagesDataState,
                    pagesFlyer: flyerDetailsState.flyerPages!.sort(compare),
                    selectedPages: flyerDetailsState.flyerPages.length
                        ? [flyerDetailsState.flyerPages[selectedPagesForTabState.pageNo === 0 ? 0
                            : selectedPagesForTabState.pageNo - 1]] : [],
                    lastSelectedPage: flyerDetailsState.flyerPages.length
                        ? [flyerDetailsState.flyerPages[selectedPagesForTabState.pageNo === 0 ? 0 : selectedPagesForTabState.pageNo - 1]]
                        : [],
                });
            } else {
                setPagesDataState({
                    ...pagesDataState,
                    pagesFlyer: flyerDetailsState.flyerPages!,
                });
            }
        }
    }, [flyerDetailsState]);

    useEffect(() => {
        if (isXs) {
            const data = {
                pageNo: 0,
                selectedTabNum: 0
            }
            dispatch(setSelectedPageForTabs(data));
            // history.push(`/flyersCatalog`);
        }
    }, [isXs]);


    useEffect(() => {
        // hideMenu();
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
        if (pagesDataState.selectedPages.length) {
            if (pagesState.type === ActionType.DELETE_PAGE_SUCCESS) {
                const allDeletedPagesNo: any = [];
                const newPages = pagesDataState.pagesFlyer?.filter(page => {
                    const isIncludeInSelectedPages = pagesDataState.selectedPages.some((key: any) => key.flpRecId === page.flpRecId);
                    if (!isIncludeInSelectedPages) {
                        return page;
                    } else {
                        allDeletedPagesNo.push(page.flpPageNo);
                    }
                }).map((page, index) => {
                    page.flpPageNo = index + 1;
                    return page;
                });
                if (pagesDataState.isRemoveAllPagesFromFlyer) {
                    setPagesDataState({
                        ...pagesDataState,
                        selectedPages: [pagesDataState.selectedPages[0]],
                        isRemoveAllPagesFromFlyer: false,
                        pagesFlyer: [pagesDataState.selectedPages[0]]
                    })
                    const data = {
                        pageNo: 0
                    }
                    dispatch(setSelectedPageForTabs(data));

                    dispatch(updateFlyerDetailsState({
                        ...flyerDetailsState,
                        flyerPages: [pagesDataState.selectedPages[0]]
                    }));
                    deleteImagesFromPagesRequest();
                } else {
                    if (allDeletedPagesNo[0] > newPages!.length) {
                        console.log([newPages![newPages!.length - 1]]);
                        setPagesDataState({
                            ...pagesDataState,
                            selectedPages: [newPages![newPages!.length - 1]],
                            pagesFlyer: newPages!
                        });
                        const data = {
                            pageNo: newPages!.length
                        }
                        dispatch(setSelectedPageForTabs(data));
                    } else {
                        setPagesDataState({
                            ...pagesDataState,
                            selectedPages: [newPages![allDeletedPagesNo[0] - 1]],
                            pagesFlyer: newPages!
                        });
                        const data = {
                            pageNo: allDeletedPagesNo[0]
                        }
                        dispatch(setSelectedPageForTabs(data));

                    }
                    dispatch(updateFlyerDetailsState({
                        ...flyerDetailsState,
                        flyerPages: newPages!
                    }))

                }
            } else if (pagesState.type === ActionType.DELETE_PAGE_IMAGE_SUCCESS) {
                const newPagesArr = pagesState.data.data;
                const newPages = pagesDataState.pagesFlyer?.map(page => {
                    newPagesArr.forEach((value: any) => {
                        if (value.flpRecId === page.flpRecId) {
                            page = value;
                            return false;
                        }
                    })
                    return page;
                });
                setPagesDataState({
                    ...pagesDataState,
                    selectedPages: newPagesArr,
                    pagesFlyer: newPages!
                })
                dispatch(updateFlyerDetailsState({
                    ...flyerDetailsState,
                    flyerPages: newPages!
                }))
            } else if (pagesState.type === ActionType.MOVE_PAGES_BEFORE_SUCCESS) {
                //replace pages which should move
                const arrOfPagesAfterDelete = pagesDataState.pagesFlyer?.filter(page => {
                    const isIncludeInSelectedPages = pagesDataState.selectedPages.some((key: any) => key.flpRecId === page.flpRecId);
                    return !isIncludeInSelectedPages && page;
                })
                let targetIndex: number = 0;
                arrOfPagesAfterDelete?.forEach((page, index) => {
                    if (page.flpPageNo === pagesDataState.pageNoForMoveBefore) {
                        targetIndex = index;
                        return false;
                    }
                })
                //paste paged which should move to new array
                arrOfPagesAfterDelete?.splice(targetIndex, 0, ...pagesDataState.selectedPages)
                const newPages = arrOfPagesAfterDelete?.map((key, index) => {
                    key.flpPageNo = index + 1;
                    return key;
                });
                setPagesDataState({
                    ...pagesDataState,
                    pagesFlyer: newPages!
                })
                dispatch(updateFlyerDetailsState({
                    ...flyerDetailsState,
                    flyerPages: newPages!
                }))
            } else if (pagesState.type === ActionType.INSERT_PAGE_SUCCESS) {
                const newPageObject = pagesState.data.data;
                pagesDataState.pagesFlyer?.splice(newPageObject.flpPageNo - 1, 0, newPageObject)
                const newPages = pagesDataState.pagesFlyer?.map((key, index) => {
                    key.flpPageNo = index + 1;
                    return key;
                });
                const data = {
                    pageNo: newPageObject.flpPageNo
                }
                dispatch(setSelectedPageForTabs(data));
                setPagesDataState({
                    ...pagesDataState,
                    selectedPages: [newPageObject],
                    pagesFlyer: newPages!
                })
                dispatch(updateFlyerDetailsState({
                    ...flyerDetailsState,
                    flyerPages: newPages!
                }))
            } else if (pagesState.type === ActionType.UPLOAD_IMAGES_TO_PAGES_SUCCESS) {
                // const newPagesArr = pagesState.data.data;
                // const newPages = pagesDataState.pagesFlyer?.map(page => {
                //     newPagesArr.forEach((value: any) => {
                //         if (value.flpRecId === page.flpRecId) {
                //             page = value;
                //             return false;
                //         }
                //     })
                //     return page;
                // });
                // console.log(newPages);
                // setPagesDataState({
                //     ...pagesDataState,
                //     selectedPages: newPagesArr,
                //     pagesFlyer: newPages!
                // })
                // dispatch(updateFlyerDetailsState({
                //     ...flyerDetailsState,
                //     flyerPages: newPages!
                // }))
            } else if (pagesState.type === ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_SUCCESS) {
                if (pagesState.data.severityLevel.toLowerCase() === "info") {
                    let messages: string[] = pagesState.data.userFriendlyMessage.split(`\r\n`)
                        .filter((key: any) => key !== '');
                    setModalSetup({
                        isOpen: true,
                        modalName: "successfullyUploadWithSomeErrors",
                        messages: messages
                    })
                }

            }
        }

    }, [pagesState.type]);


    const compare = (a: any, b: any) => {
        if (Number(a.flpPageNo) < Number(b.flpPageNo)) {
            return -1;
        }
        if (Number(a.flpPageNo) > Number(b.flpPageNo)) {
            return 1;
        }
        return 0;
    }


    useEffect(() => {
        if (pagesDataState.selectedPages.length === 1 && pagesDataState.isDoubleClick) {
            doubleClickOnPage();
        }
        window.addEventListener('keydown', keydownHandler);
        return () => {
            window.removeEventListener('keydown', keydownHandler);
        }
    }, [pagesDataState.selectedPages]);

    const onAddImageToPageFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files!;
        const imagesArray = [];
        let isOnlyImages = true;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            imagesArray?.push({
                flpCaption: "",
                flpDisplayCaption: "",
                flpImage: file.name,
                file: file
            });
            if (file.type === 'application/pdf') {
                isOnlyImages = false;
            }
        }
        const data = {
            Images: imagesArray,
            UiLanguageCultureCode: 'en-US',
            Pages: pagesDataState.selectedPages
        }

        const itPagesHasThumbnails = pagesDataState.selectedPages?.some((key: any) => key.flyImageThumbnailUrl && key.flyImageThumbnailUrl.indexOf('jpg') > -1);
        const isAllSelectedPagesHasNotLoadedImages = pagesDataState.selectedPages?.every((key: any) => pagesDataState.notLoaderPagesImagesCodes.includes(key.flpRecId));
        if (imagesArray.length > pagesDataState.selectedPages?.length || imagesArray.length !== pagesDataState.selectedPages?.length && isOnlyImages) {
            setModalSetup({
                isOpen: true,
                modalName: "uploadImagesToPageNotEqualSelectedPages",
                messages: []
            })
        } else {
            if (itPagesHasThumbnails && !isAllSelectedPagesHasNotLoadedImages) {
                setPagesDataState({
                    ...pagesDataState,
                    dataForUploadImageToPage: data
                })
                setModalSetup({
                    isOpen: true,
                    modalName: "uploadImageToPage",
                    messages: []
                })
            } else {
                dispatch(startUploadingImagesProgressPopup());
                dispatch(uploadImagesToPages(data));
            }
        }
    }

    const confirmUploadImageToPage = () => {
        dispatch(uploadImagesToPages(pagesDataState.dataForUploadImageToPage));
        dispatch(startUploadingImagesProgressPopup());
        setModalSetup({
            isOpen: false,
            modalName: "",
            messages: []
        })
    }

    const keydownHandler = (e: any) => {
        if (e.code === 'KeyA' && e.ctrlKey) {
            e.preventDefault();
            if (pagesDataState.selectedPages.length === pagesDataState.pagesFlyer?.length) {
                setPagesDataState({
                    ...pagesDataState,
                    selectedPages: [],
                    isSelectedAll: false
                })
            } else {
                setPagesDataState({
                    ...pagesDataState,
                    selectedPages: pagesDataState.pagesFlyer,
                    isSelectedAll: true
                })
            }
        }
    }

    const deletePagesPopupConfirm = () => {
        setModalSetup({
            isOpen: true,
            modalName: "confirmHardDelete",
            messages: []
        })
    }

    const deleteImageOrPageConfirm = (): void => {
        const hasContent: boolean = pagesDataState.selectedPages.some((page: FlyerPageDto) => page.flyerPageSpots!.length > 0);
        const hasImage: boolean = pagesDataState.selectedPages.some((page: FlyerPageDto) => page.flyImageThumbnailUrl! && page.flyImageThumbnailUrl!.indexOf('jpg') > 0);

        if (hasContent) {
            setModalSetup({
                isOpen: true,
                modalName: "confirmSoftOrHardDelete",
                messages: []
            })
        } else if (!hasContent && !hasImage) {
            deletePagesPopupConfirm();
        } else {
            deleteImagesFromPagesRequest();
        }
    }
    const deletePagesRequest = () => {
        setModalSetup({
            isOpen: false,
            modalName: "",
            messages: []
        })
        let onlyIds: string[] = [];
        pagesDataState.selectedPages.forEach((value: any) => {
            onlyIds.push(value.flpRecId)
        })
        if (pagesDataState.selectedPages.length === pagesDataState.pagesFlyer.length) {
            const arrayForDelete = onlyIds.slice(1);
            setPagesDataState({
                ...pagesDataState,
                isRemoveAllPagesFromFlyer: true
            })
            dispatch(deletePageFromPages({pages: arrayForDelete, uiLanguageCultureCode: "en-US"}));
        } else {
            dispatch(deletePageFromPages({pages: onlyIds, uiLanguageCultureCode: "en-US"}));
        }
    }

    const deleteImagesFromPagesRequest = () => {
        let onlyIds: string[] = [];
        pagesDataState.selectedPages.forEach((page: any) => {
            onlyIds.push(page.flpRecId);
        });
        setModalSetup({
            isOpen: false,
            modalName: "",
            messages: []
        })
        dispatch(deleteImagesFromPages({pages: onlyIds, uiLanguageCultureCode: "en-US"}));
    }

    const insertPageRequest = (data: any) => {
        const {flyerPages} = flyerDetailsState;
        if (flyerPages.length + 1 > 1000) {
            setModalSetup({
                isOpen: true,
                modalName: "moreThanAllowed",
                messages: []
            })
        } else {
            dispatch(insertPageToFlyer(data));
        }
    }
    const movePageRequest = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        const numPageForMove = Number(event.target.value);
        setPagesDataState({...pagesDataState, pageNoForMoveBefore: numPageForMove});
        let onlyIds: string[] = pagesDataState.selectedPages.map((page: any) => page.flpRecId);
        const data = {
            pageNo: numPageForMove,
            uiLanguageCultureCode: 'en-US',
            flyerPages: onlyIds
        };
        dispatch(movePageBeforeInFlyer(data));
    };

    const selectAllHandler = () => {
        setPagesDataState({
            ...pagesDataState,
            selectedPages: pagesDataState.isSelectedAll ? [] : pagesDataState.pagesFlyer,
            isSelectedAll: !pagesDataState.isSelectedAll
        });
    }
    const doubleClickOnPage = () => {
        try {
            const pageNo = pagesDataState.selectedPages[0].flpPageNo!;
            const selectedTabNum = 2;
            dispatch(setSelectedPageForTabs({pageNo, selectedTabNum}));
        } catch (e) {
        }
    }
    const loadMore = () => {
        if (records === pagesDataState.pagesFlyer.length) {
            setHasMore(false);
        } else {
            setTimeout(() => {
                setRecords(records + itemsPerPage);
            }, 200);
        }
    };
    const setDefaultPageNumberForTabs = (pageNumber: number) => {
        const data = {
            pageNo: pageNumber
        }
        dispatch(setSelectedPageForTabs(data));

    }


    const setActivePages = useCallback((newActivePagesArray: FlyerPageDto[], page: FlyerPageDto | null, isSelectAll: boolean, pageNumberForTab: number | null) => {
        setPagesDataState(prevState => {
            const {lastSelectedPage} = prevState;
            return {
                ...prevState,
                selectedPages: newActivePagesArray,
                lastSelectedPage: page?.flpRecId ? [page] : lastSelectedPage,
                isSelectedAll: isSelectAll
            };
        });
        if (pageNumberForTab !== null) {
            setDefaultPageNumberForTabs(pageNumberForTab);
        }
    }, [setPagesDataState, setDefaultPageNumberForTabs]);


    const showItems = (data: FlyerPageDto[]) => {
        let items = [];
        if (data.length !== 0) {
            for (let i = 0; i < records; i++) {
                if (data[i]?.flpRecId) {
                    // console.log(1);
                    const columnNumbersWidth = setColumnNumbersWidth(isMd, isLg, isMdForContent, isXs, isSm, isShowRightPanel);
                    const isActive = isActivePage(pagesDataState, data[i]);
                    items.push(
                        <Page
                            key={data[i].flpRecId}
                            dataKey={data[i]}
                            isActivePage={isActive}
                            isLastActivePage={isLastSelectedPage(pagesDataState, data[i])}
                            deleteImagesFromPages={deleteImageOrPageConfirm}
                            deletePages={deletePagesPopupConfirm}
                            insertPageCallback={insertPageRequest}
                            movePageCallback={movePageRequest}
                            onAddImageToPageFile={onAddImageToPageFile}
                            setPagesDataState={setPagesDataState}
                            pagesDataState={pagesDataState}
                            columnNumbersWidth={columnNumbersWidth}
                            setActivePages={setActivePages}
                        />
                    );
                }
            }
        }
        return items;
    };

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: modalSetup.messages,
        modalName: modalSetup.modalName,
        confirmOnClick: {
            onHardDeleteClick: deletePagesRequest,
            onSoftDeleteClick: deleteImagesFromPagesRequest,
            onUploadImage: confirmUploadImageToPage
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);


    const setColumnNumbersWidth = (isMd: boolean, isLg: boolean, isMdForContent: boolean, isXs: boolean, isSm: boolean, isShowRightPanel: boolean): number => {
        if (!isShowRightPanel) {
            if (isXs) {
                return 12;
            } else if (isSm) {
                return 6;
            } else if (isMd) {
                return 4;
            } else if (isLg) {
                return 3;
            } else {
                return 2.4;
            }
        } else {
            if (!isMd) {
                if (isLg && !isMdForContent) {
                    return 8;
                } else if (isMdForContent) {
                    return 8;
                } else {
                    return 4;
                }
            } else {
                if (isXs) {
                    return 12;
                } else if (isSm) {
                    return 6;
                } else if (isLg || isMdForContent) {
                    return 4;
                } else {
                    return 4;
                }
            }
        }
    }

    const isActivePage = (pagesDataState: PagesDataStateDto, page: FlyerPageDto) => {
        return pagesDataState.selectedPages.some(val => val.flpRecId === page.flpRecId);
    }

    const isLastSelectedPage = (pagesDataState: PagesDataStateDto, page: FlyerPageDto) => {
        return pagesDataState.lastSelectedPage.some(val => val.flpRecId === page.flpRecId);
    }

    const approveSelectedPages = () => {
        const pagesIdsWhichCanBeChangeQualification: number[] = pagesDataState.selectedPages
            .map((page: FlyerPageDto) => page.flpRecId!);

        dispatch(changeQualificationStatusForPage(
            pagesIdsWhichCanBeChangeQualification,
            flyerDetailsState?.flyLacRec?.lacCode!,
            2,
            // isApproveAll ? 2 : 1,
            flyerDetailsState,
        ));
    }

    const pages = useMemo(() => {
        if (pagesDataState.pagesFlyer) {
            const columnNumbersWidth = setColumnNumbersWidth(isMd, isLg, isMdForContent, isXs, isSm, isShowRightPanel);
            return pagesDataState.pagesFlyer.map((page) => {
                const isActive = isActivePage(pagesDataState, page);
                return (
                    <Page
                        key={page.flpRecId}
                        dataKey={page}
                        isActivePage={isActive}
                        isLastActivePage={isLastSelectedPage(pagesDataState, page)}
                        deleteImagesFromPages={deleteImageOrPageConfirm}
                        deletePages={deletePagesPopupConfirm}
                        insertPageCallback={insertPageRequest}
                        movePageCallback={movePageRequest}
                        onAddImageToPageFile={onAddImageToPageFile}
                        setPagesDataState={setPagesDataState}
                        pagesDataState={pagesDataState}
                        columnNumbersWidth={columnNumbersWidth}
                        setActivePages={setActivePages}
                    />
                );
            });
        }
        return [];
    }, [pagesDataState, isMd, isLg, isMdForContent, isXs, isSm, isShowRightPanel]);

    return (
        <div className={styles.container}>
            <div className={pagesState.loading || flippingFlyerState.loading ? styles.loading : ''}>
                {(pagesState.loading || flippingFlyerState.loading) && <PageSpinner/>}
            </div>
            <Grid container columns={16} sx={{height: "100%"}}>
                <Grid item xl={!isShowRightPanel ? 15.8 : 10} lg={!isShowRightPanel ? 15.8 : 8} sm={16} md={16} xs={16}
                      sx={{
                          flexFlow: "column",
                          display: "flex",
                          height: "100%",
                          position: "relative",
                          transition: `all ${rightPanelAnimationTimeInMs}ms`,
                      }}
                >
                    <div className={styles.header}>
                        <div className={styles.left_side}>
                            <Box
                                title={!uploadImagesPopup.processingFinished ? "An upload is still in process" : ''}
                            >
                                <div
                                    className={`${styles.fake_btn} ${(pagesDataState.selectedPages.length === 0 || flyerDetailsState.flyFstRec.fstCaption === "Published" || !uploadImagesPopup.processingFinished || isUserViewer) && styles.disabled}`}>
                                    <LabelFileSelector
                                        isDisabled={pagesDataState.selectedPages.length === 0 || flyerDetailsState.flyFstRec.fstCaption === "Published" || !uploadImagesPopup.processingFinished || isUserViewer}
                                        multiple={true}
                                        accept={".jpg, application/pdf"}
                                        fileId="pages_data"
                                        onChange={onAddImageToPageFile}
                                    >
                                        <Typography color={"#ffffff"}>
                                            Upload Page Images
                                        </Typography>
                                    </LabelFileSelector>
                                </div>
                            </Box>
                            <Typography className={styles.pagesCounter}>
                                {pagesDataState.pagesFlyer?.length} pages
                            </Typography>
                            <Box sx={{
                                display: `flex`,
                                height: `100%`
                            }}>
                                <QualityCheck/>
                            </Box>
                            <Box sx={{
                                display: `flex`,
                            }}>
                                <Button
                                    disabled={pagesDataState.selectedPages.length === 0 || isUserViewer || isUserEditor}
                                    sx={{
                                        padding: "4px 8px",
                                        color: "#000000",
                                        fontWeight: "700",
                                        fontSize: "16px",
                                        "&:hover": {
                                            backgroundColor: "#0147801A"
                                        },
                                    }}
                                    onClick={approveSelectedPages}
                                >
                                    Approve
                                </Button>
                            </Box>

                        </div>
                        <div className={styles.right_side}>
                            <div>
                                <label>
                                    <input onChange={selectAllHandler} type="checkbox"
                                           checked={pagesDataState.isSelectedAll}/>
                                    <div style={{userSelect: "none"}}>Select All</div>
                                </label>
                            </div>
                            <div>
                                <button className={
                                    (pagesDataState.pagesFlyer?.length === 1
                                        || pagesDataState.selectedPages.length === 0
                                        || flyerDetailsState.flyFstRec.fstCaption === "Published"
                                        || isUserViewer
                                    )
                                        ? styles.disabled
                                        : ''} onClick={deletePagesPopupConfirm}>
                                    <DeleteIcon/>
                                </button>
                            </div>
                        </div>
                    </div>
                    <Box className={classes.contentPagesWrapper}>
                        {
                            pagesDataState.pagesFlyer.length > itemsPerPage &&
                            <InfiniteScroll
                                pageStart={0}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                // loader={<h4 className="loader" style={{
                                //     display: hasMore ? "block" : "none"
                                // }}>Loading...</h4>}
                                useWindow={false}
                            >
                                <Grid container
                                      columns={24}
                                      columnSpacing={"12px"}
                                      rowSpacing={"12px"}
                                >
                                    {showItems(pagesDataState.pagesFlyer)}
                                </Grid>
                            </InfiniteScroll>
                        }
                        {
                            pagesDataState.pagesFlyer.length <= itemsPerPage &&
                            <Grid container
                                  columns={24}
                                  columnSpacing={"12px"}
                                  rowSpacing={"12px"}
                            >
                                {pages}
                            </Grid>
                        }


                    </Box>
                </Grid>
                {
                    !isMd &&
                    <Grid item xs
                          sx={{
                              flexFlow: "column",
                              display: "flex",
                              height: "100%",
                              overflow: "hidden",
                          }}
                    >
                        <FlyerDetailsRightPanel
                            activeFlyers={[{...flyerDetailsState}]}
                            flyersForHold={[]}
                            rightPanelAnimationTimeInMs={rightPanelAnimationTimeInMs}
                            isPagesTab={true}
                        />
                    </Grid>
                }
            </Grid>

            {modalSetup.isOpen && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={modalSetup.isOpen}
                handleClose={() => setModalSetup({
                    isOpen: false,
                    modalName: "",
                    messages: []
                })
                }
            />
            }
        </div>
    )
}